import React from 'react';
import { FaInfoCircle, FaTimes } from 'react-icons/fa';

const AnnouncementBanner = ({ announcement, onClose }) => {
  if (!announcement || !announcement.active) return null;

  return (
    <div style={{
      background: announcement.color || '#ffb703',
      color: 'white',
      padding: '12px 20px',
      textAlign: 'center',
      fontWeight: '600',
      fontSize: '14px',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      animation: 'slideDown 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      lineHeight: '1.4'
    }}>
      <style>
        {`
          @keyframes slideDown {
            from { transform: translateY(-100%); }
            to { transform: translateY(0); }
          }
        `}
      </style>
      <FaInfoCircle style={{ flexShrink: 0, opacity: 0.8, fontSize: '16px' }} />
      <span style={{ 
        flex: 1, 
        letterSpacing: '0.3px',
        textShadow: '0 1px 2px rgba(0,0,0,0.1)'
      }}>
        {announcement.text}
      </span>
      {onClose && (
        <button 
          onClick={onClose}
          style={{
            background: 'rgba(255, 255, 255, 0.15)',
            border: 'none',
            color: 'white',
            borderRadius: '6px',
            padding: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.2s',
            flexShrink: 0
          }}
          onMouseOver={e => e.target.style.background = 'rgba(255, 255, 255, 0.25)'}
          onMouseOut={e => e.target.style.background = 'rgba(255, 255, 255, 0.15)'}
        >
          <FaTimes style={{ fontSize: '12px' }} />
        </button>
      )}
    </div>
  );
};

export default AnnouncementBanner;
